/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Oracle RDS API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseInt,
  ApiResponseOracleParameterDetailRs,
  ApiResponseSessionManagerRS,
  AsmByIntervalV7Response,
  AsmGroupV7Response,
  AsmSizeForecastV7Response,
  BindSqlResponse,
  GetV7OracleActiveSessionDetailSqlTextParams,
  GetV7OracleActiveSessionListParams,
  GetV7OracleAsmByIntervalParams,
  GetV7OracleAsmGroupsParams,
  GetV7OracleAsmSizeForecastParams,
  GetV7OracleBindSqlParams,
  GetV7OracleLongActiveSessionParams,
  GetV7OracleParameterDetailByInstanceIdAndParameterNameParams,
  GetV7OracleParameterHistoryParams,
  GetV7OraclePlanAnalysisListParams,
  GetV7OraclePlanByInstanceIdParams,
  GetV7OraclePlanByIntervalParams,
  GetV7OraclePlanDiffParams,
  GetV7OraclePlanHashValuesBySqlIdParams,
  GetV7OracleSessionByUsageParams,
  GetV7OracleSessionManagerListByInstanceIdParams,
  GetV7OracleSessionsByInstanceIdAndSidParams,
  GetV7OracleSessionsMetricByInstanceIdParams,
  GetV7OracleSessionsParams,
  GetV7OracleSessionsSecondParams,
  GetV7OracleSqlByIntervalMultiParams,
  GetV7OracleSqlByIntervalParams,
  GetV7OracleSqlByPlanParams,
  GetV7OracleSqlListByIntervalParams,
  GetV7OracleSqlListParams,
  GetV7OracleSqlPlanReasonByInstanceIdParams,
  GetV7OracleSqlSummaryListParams,
  GetV7OracleSqlSummaryParams,
  GetV7OracleSqlsParams,
  GetV7OracleTablespaceByIntervalParams,
  GetV7OracleTempIntervalParams,
  GetV7OracleTimeModelByIntervalParams,
  GetV7OracleTopModuleParams,
  GetV7OracleTopSchemaParams,
  GetV7OracleTopSegmentParams,
  GetV7OracleTopSqlParams,
  GetV7OracleTopTablespaceParams,
  GetV7OracleUndoIntervalParams,
  GetV7OracleWaitChainParams,
  GetV7OracleWaitChainSecondParams,
  GetV7OracleWaitClassParams,
  GetV7OracleWaitClassRatioParams,
  GetV7OracleWaitEventParams,
  GetV7OracleWaitSqlListParams,
  LastParameterResponse,
  LongActiveSessionResponse,
  MultiInstanceRequestBody,
  OverviewV7Response,
  ParameterResponse,
  PlanAnalysisListResponse,
  PlanByIntervalV7Response,
  PlanDiffResponse,
  PlanHashValuesBySqlIdV7Response,
  PostV7OracleOverviewParams,
  PostV7OracleSessionCountParams,
  PostV7OracleSessionsKillSessionByInstanceIdParams,
  PostV7OracleTimeModelByIntervalParams,
  PostV7OracleWaitClassParams,
  SessionByUsageV7Response,
  SessionListV7Response,
  SessionMetricV4Response,
  SessionSearchListV7Response,
  SessionTargetDetailV7Response,
  SessionTypeV7Response,
  SqlByPlanV7Response,
  SqlByWaitEventV7Response,
  SqlIntervalMultiV7Response,
  SqlIntervalV7Response,
  SqlListByIntervalV7Response,
  SqlPlanReasonV7Response,
  SqlPlanV4Response,
  SqlRtmSummaryV7Response,
  SqlSummaryListV7Response,
  SqlSummaryV7Response,
  SqlTextBySqlIdV7Response,
  TablespaceByIntervalV7Response,
  TempIntervalSummaryV7Response,
  TimeModelByIntervalV7Response,
  TopModuleV7Response,
  TopSchemaV7Response,
  TopSegmentV7Response,
  TopSqlV7Response,
  TopTablespaceV7Response,
  UndoIntervalSummaryV7Response,
  UndoTempRatioV7Response,
  WaitChainWithDeadLockV7Response,
  WaitClassRatioV7Response,
  WaitClassV7Response,
  WaitEventResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary sqlText
 */
export const getV7OracleActiveSessionDetailSqlText = (
  params: MaybeRef<GetV7OracleActiveSessionDetailSqlTextParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlTextBySqlIdV7Response>(
    {
      url: `/api/v7/oracle/active-session-detail/sql-text`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7OracleActiveSessionDetailSqlTextQueryKey = (
  params?: MaybeRef<GetV7OracleActiveSessionDetailSqlTextParams>,
) => {
  return [
    'api',
    'v7',
    'oracle',
    'active-session-detail',
    'sql-text',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7OracleActiveSessionDetailSqlTextQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleActiveSessionDetailSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleActiveSessionDetailSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleActiveSessionDetailSqlText>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleActiveSessionDetailSqlTextQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7OracleActiveSessionDetailSqlText>>
  > = ({ signal }) => getV7OracleActiveSessionDetailSqlText(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleActiveSessionDetailSqlText>>,
    TError,
    TData
  >;
};

export type GetV7OracleActiveSessionDetailSqlTextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleActiveSessionDetailSqlText>>
>;
export type GetV7OracleActiveSessionDetailSqlTextQueryError = ErrorType<unknown>;

/**
 * @summary sqlText
 */

export function useGetV7OracleActiveSessionDetailSqlText<
  TData = Awaited<ReturnType<typeof getV7OracleActiveSessionDetailSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleActiveSessionDetailSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleActiveSessionDetailSqlText>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleActiveSessionDetailSqlTextQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getActiveSessionList
 */
export const getV7OracleActiveSessionList = (
  params: MaybeRef<GetV7OracleActiveSessionListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SessionListV7Response>(
    { url: `/api/v7/oracle/active-session-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleActiveSessionListQueryKey = (
  params?: MaybeRef<GetV7OracleActiveSessionListParams>,
) => {
  return ['api', 'v7', 'oracle', 'active-session-list', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleActiveSessionListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleActiveSessionList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleActiveSessionListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleActiveSessionList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleActiveSessionListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleActiveSessionList>>> = ({
    signal,
  }) => getV7OracleActiveSessionList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleActiveSessionList>>,
    TError,
    TData
  >;
};

export type GetV7OracleActiveSessionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleActiveSessionList>>
>;
export type GetV7OracleActiveSessionListQueryError = ErrorType<unknown>;

/**
 * @summary getActiveSessionList
 */

export function useGetV7OracleActiveSessionList<
  TData = Awaited<ReturnType<typeof getV7OracleActiveSessionList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleActiveSessionListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleActiveSessionList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleActiveSessionListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary asmByInterval
 */
export const getV7OracleAsmByInterval = (
  params: MaybeRef<GetV7OracleAsmByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<AsmByIntervalV7Response>(
    { url: `/api/v7/oracle/asm-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleAsmByIntervalQueryKey = (
  params?: MaybeRef<GetV7OracleAsmByIntervalParams>,
) => {
  return ['api', 'v7', 'oracle', 'asm-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleAsmByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleAsmByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleAsmByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleAsmByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleAsmByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleAsmByInterval>>> = ({
    signal,
  }) => getV7OracleAsmByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleAsmByInterval>>,
    TError,
    TData
  >;
};

export type GetV7OracleAsmByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleAsmByInterval>>
>;
export type GetV7OracleAsmByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary asmByInterval
 */

export function useGetV7OracleAsmByInterval<
  TData = Awaited<ReturnType<typeof getV7OracleAsmByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleAsmByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleAsmByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleAsmByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary asmGroup
 */
export const getV7OracleAsmGroups = (
  params: MaybeRef<GetV7OracleAsmGroupsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<AsmGroupV7Response>(
    { url: `/api/v7/oracle/asm-groups`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleAsmGroupsQueryKey = (params?: MaybeRef<GetV7OracleAsmGroupsParams>) => {
  return ['api', 'v7', 'oracle', 'asm-groups', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleAsmGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleAsmGroups>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleAsmGroupsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleAsmGroups>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleAsmGroupsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleAsmGroups>>> = ({ signal }) =>
    getV7OracleAsmGroups(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleAsmGroups>>,
    TError,
    TData
  >;
};

export type GetV7OracleAsmGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleAsmGroups>>
>;
export type GetV7OracleAsmGroupsQueryError = ErrorType<unknown>;

/**
 * @summary asmGroup
 */

export function useGetV7OracleAsmGroups<
  TData = Awaited<ReturnType<typeof getV7OracleAsmGroups>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleAsmGroupsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleAsmGroups>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleAsmGroupsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary asmSizeForecast
 */
export const getV7OracleAsmSizeForecast = (
  params: MaybeRef<GetV7OracleAsmSizeForecastParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<AsmSizeForecastV7Response>(
    { url: `/api/v7/oracle/asm-size-forecast`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleAsmSizeForecastQueryKey = (
  params?: MaybeRef<GetV7OracleAsmSizeForecastParams>,
) => {
  return ['api', 'v7', 'oracle', 'asm-size-forecast', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleAsmSizeForecastQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleAsmSizeForecast>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleAsmSizeForecastParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleAsmSizeForecast>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleAsmSizeForecastQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleAsmSizeForecast>>> = ({
    signal,
  }) => getV7OracleAsmSizeForecast(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleAsmSizeForecast>>,
    TError,
    TData
  >;
};

export type GetV7OracleAsmSizeForecastQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleAsmSizeForecast>>
>;
export type GetV7OracleAsmSizeForecastQueryError = ErrorType<unknown>;

/**
 * @summary asmSizeForecast
 */

export function useGetV7OracleAsmSizeForecast<
  TData = Awaited<ReturnType<typeof getV7OracleAsmSizeForecast>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleAsmSizeForecastParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleAsmSizeForecast>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleAsmSizeForecastQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getBindSql
 */
export const getV7OracleBindSql = (
  params: MaybeRef<GetV7OracleBindSqlParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<BindSqlResponse>(
    { url: `/api/v7/oracle/bind-sql`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleBindSqlQueryKey = (params?: MaybeRef<GetV7OracleBindSqlParams>) => {
  return ['api', 'v7', 'oracle', 'bind-sql', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleBindSqlQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleBindSql>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleBindSqlParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7OracleBindSql>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleBindSqlQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleBindSql>>> = ({ signal }) =>
    getV7OracleBindSql(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleBindSql>>,
    TError,
    TData
  >;
};

export type GetV7OracleBindSqlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleBindSql>>
>;
export type GetV7OracleBindSqlQueryError = ErrorType<unknown>;

/**
 * @summary getBindSql
 */

export function useGetV7OracleBindSql<
  TData = Awaited<ReturnType<typeof getV7OracleBindSql>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleBindSqlParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7OracleBindSql>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleBindSqlQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getLongActiveSession
 */
export const getV7OracleLongActiveSession = (
  params: MaybeRef<GetV7OracleLongActiveSessionParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<LongActiveSessionResponse>(
    { url: `/api/v7/oracle/long-active-session`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleLongActiveSessionQueryKey = (
  params?: MaybeRef<GetV7OracleLongActiveSessionParams>,
) => {
  return ['api', 'v7', 'oracle', 'long-active-session', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleLongActiveSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleLongActiveSession>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleLongActiveSessionParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleLongActiveSession>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleLongActiveSessionQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleLongActiveSession>>> = ({
    signal,
  }) => getV7OracleLongActiveSession(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleLongActiveSession>>,
    TError,
    TData
  >;
};

export type GetV7OracleLongActiveSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleLongActiveSession>>
>;
export type GetV7OracleLongActiveSessionQueryError = ErrorType<unknown>;

/**
 * @summary getLongActiveSession
 */

export function useGetV7OracleLongActiveSession<
  TData = Awaited<ReturnType<typeof getV7OracleLongActiveSession>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleLongActiveSessionParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleLongActiveSession>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleLongActiveSessionQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Oracle] MultiView - Overview
 */
export const postV7OracleOverview = (
  multiInstanceRequestBody: MaybeRef<MultiInstanceRequestBody>,
  params?: MaybeRef<PostV7OracleOverviewParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiInstanceRequestBody = unref(multiInstanceRequestBody);
  params = unref(params);

  return customAxiosInstance<OverviewV7Response>(
    {
      url: `/api/v7/oracle/overview`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiInstanceRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7OracleOverviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7OracleOverview>>,
    TError,
    { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleOverviewParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7OracleOverview>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleOverviewParams },
  TContext
> => {
  const mutationKey = ['postV7OracleOverview'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7OracleOverview>>,
    { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleOverviewParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV7OracleOverview(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7OracleOverviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7OracleOverview>>
>;
export type PostV7OracleOverviewMutationBody = BodyType<MultiInstanceRequestBody>;
export type PostV7OracleOverviewMutationError = ErrorType<unknown>;

/**
 * @summary [Oracle] MultiView - Overview
 */
export const usePostV7OracleOverview = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7OracleOverview>>,
      TError,
      { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleOverviewParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7OracleOverview>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleOverviewParams },
  TContext
> => {
  const mutationOptions = getPostV7OracleOverviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getParameterHistory
 */
export const getV7OracleParameterHistory = (
  params: MaybeRef<GetV7OracleParameterHistoryParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ParameterResponse>(
    { url: `/api/v7/oracle/parameter/history`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleParameterHistoryQueryKey = (
  params?: MaybeRef<GetV7OracleParameterHistoryParams>,
) => {
  return ['api', 'v7', 'oracle', 'parameter', 'history', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleParameterHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleParameterHistory>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleParameterHistoryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleParameterHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleParameterHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleParameterHistory>>> = ({
    signal,
  }) => getV7OracleParameterHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleParameterHistory>>,
    TError,
    TData
  >;
};

export type GetV7OracleParameterHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleParameterHistory>>
>;
export type GetV7OracleParameterHistoryQueryError = ErrorType<unknown>;

/**
 * @summary getParameterHistory
 */

export function useGetV7OracleParameterHistory<
  TData = Awaited<ReturnType<typeof getV7OracleParameterHistory>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleParameterHistoryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleParameterHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleParameterHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getParameterList
 */
export const getV7OracleParameterByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<LastParameterResponse>(
    { url: `/api/v7/oracle/parameter/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7OracleParameterByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'oracle', 'parameter', instanceId] as const;
};

export const getGetV7OracleParameterByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleParameterByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleParameterByInstanceId>>> = ({
    signal,
  }) => getV7OracleParameterByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7OracleParameterByInstanceId>>, TError, TData>;
};

export type GetV7OracleParameterByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleParameterByInstanceId>>
>;
export type GetV7OracleParameterByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getParameterList
 */

export function useGetV7OracleParameterByInstanceId<
  TData = Awaited<ReturnType<typeof getV7OracleParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleParameterByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary planAnalysisList
 */
export const getV7OraclePlanAnalysisList = (
  params?: MaybeRef<GetV7OraclePlanAnalysisListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<PlanAnalysisListResponse>(
    { url: `/api/v7/oracle/plan-analysis-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OraclePlanAnalysisListQueryKey = (
  params?: MaybeRef<GetV7OraclePlanAnalysisListParams>,
) => {
  return ['api', 'v7', 'oracle', 'plan-analysis-list', ...(params ? [params] : [])] as const;
};

export const getGetV7OraclePlanAnalysisListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OraclePlanAnalysisList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7OraclePlanAnalysisListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanAnalysisList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OraclePlanAnalysisListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OraclePlanAnalysisList>>> = ({
    signal,
  }) => getV7OraclePlanAnalysisList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OraclePlanAnalysisList>>,
    TError,
    TData
  >;
};

export type GetV7OraclePlanAnalysisListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OraclePlanAnalysisList>>
>;
export type GetV7OraclePlanAnalysisListQueryError = ErrorType<unknown>;

/**
 * @summary planAnalysisList
 */

export function useGetV7OraclePlanAnalysisList<
  TData = Awaited<ReturnType<typeof getV7OraclePlanAnalysisList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7OraclePlanAnalysisListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanAnalysisList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OraclePlanAnalysisListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary planByInterval
 */
export const getV7OraclePlanByInterval = (
  params: MaybeRef<GetV7OraclePlanByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<PlanByIntervalV7Response>(
    { url: `/api/v7/oracle/plan-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OraclePlanByIntervalQueryKey = (
  params?: MaybeRef<GetV7OraclePlanByIntervalParams>,
) => {
  return ['api', 'v7', 'oracle', 'plan-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7OraclePlanByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OraclePlanByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OraclePlanByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OraclePlanByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OraclePlanByInterval>>> = ({
    signal,
  }) => getV7OraclePlanByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OraclePlanByInterval>>,
    TError,
    TData
  >;
};

export type GetV7OraclePlanByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OraclePlanByInterval>>
>;
export type GetV7OraclePlanByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary planByInterval
 */

export function useGetV7OraclePlanByInterval<
  TData = Awaited<ReturnType<typeof getV7OraclePlanByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OraclePlanByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OraclePlanByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Plan Analysis] Plan 탭: diff 팝업 정보
 */
export const getV7OraclePlanDiff = (
  params: MaybeRef<GetV7OraclePlanDiffParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<PlanDiffResponse>(
    { url: `/api/v7/oracle/plan-diff`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OraclePlanDiffQueryKey = (params?: MaybeRef<GetV7OraclePlanDiffParams>) => {
  return ['api', 'v7', 'oracle', 'plan-diff', ...(params ? [params] : [])] as const;
};

export const getGetV7OraclePlanDiffQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OraclePlanDiff>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OraclePlanDiffParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanDiff>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OraclePlanDiffQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OraclePlanDiff>>> = ({ signal }) =>
    getV7OraclePlanDiff(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OraclePlanDiff>>,
    TError,
    TData
  >;
};

export type GetV7OraclePlanDiffQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OraclePlanDiff>>
>;
export type GetV7OraclePlanDiffQueryError = ErrorType<unknown>;

/**
 * @summary [Plan Analysis] Plan 탭: diff 팝업 정보
 */

export function useGetV7OraclePlanDiff<
  TData = Awaited<ReturnType<typeof getV7OraclePlanDiff>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OraclePlanDiffParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanDiff>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OraclePlanDiffQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sessionsByUsage
 */
export const getV7OracleSessionByUsage = (
  params: MaybeRef<GetV7OracleSessionByUsageParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SessionByUsageV7Response>(
    { url: `/api/v7/oracle/session-by-usage`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSessionByUsageQueryKey = (
  params?: MaybeRef<GetV7OracleSessionByUsageParams>,
) => {
  return ['api', 'v7', 'oracle', 'session-by-usage', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSessionByUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSessionByUsage>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSessionByUsageParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSessionByUsage>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSessionByUsageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSessionByUsage>>> = ({
    signal,
  }) => getV7OracleSessionByUsage(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSessionByUsage>>,
    TError,
    TData
  >;
};

export type GetV7OracleSessionByUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSessionByUsage>>
>;
export type GetV7OracleSessionByUsageQueryError = ErrorType<unknown>;

/**
 * @summary sessionsByUsage
 */

export function useGetV7OracleSessionByUsage<
  TData = Awaited<ReturnType<typeof getV7OracleSessionByUsage>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSessionByUsageParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSessionByUsage>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSessionByUsageQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sessionCountByTypePost
 */
export const postV7OracleSessionCount = (
  multiInstanceRequestBody: MaybeRef<MultiInstanceRequestBody>,
  params?: MaybeRef<PostV7OracleSessionCountParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiInstanceRequestBody = unref(multiInstanceRequestBody);
  params = unref(params);

  return customAxiosInstance<SessionTypeV7Response>(
    {
      url: `/api/v7/oracle/session-count`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiInstanceRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7OracleSessionCountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7OracleSessionCount>>,
    TError,
    { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleSessionCountParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7OracleSessionCount>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleSessionCountParams },
  TContext
> => {
  const mutationKey = ['postV7OracleSessionCount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7OracleSessionCount>>,
    { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleSessionCountParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV7OracleSessionCount(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7OracleSessionCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7OracleSessionCount>>
>;
export type PostV7OracleSessionCountMutationBody = BodyType<MultiInstanceRequestBody>;
export type PostV7OracleSessionCountMutationError = ErrorType<unknown>;

/**
 * @summary sessionCountByTypePost
 */
export const usePostV7OracleSessionCount = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7OracleSessionCount>>,
      TError,
      { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleSessionCountParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7OracleSessionCount>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleSessionCountParams },
  TContext
> => {
  const mutationOptions = getPostV7OracleSessionCountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary sessions
 */
export const getV7OracleSessions = (
  params: MaybeRef<GetV7OracleSessionsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SessionSearchListV7Response>(
    { url: `/api/v7/oracle/sessions`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSessionsQueryKey = (params?: MaybeRef<GetV7OracleSessionsParams>) => {
  return ['api', 'v7', 'oracle', 'sessions', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSessions>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSessionsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSessionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSessions>>> = ({ signal }) =>
    getV7OracleSessions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSessions>>,
    TError,
    TData
  >;
};

export type GetV7OracleSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSessions>>
>;
export type GetV7OracleSessionsQueryError = ErrorType<unknown>;

/**
 * @summary sessions
 */

export function useGetV7OracleSessions<
  TData = Awaited<ReturnType<typeof getV7OracleSessions>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSessionsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sessionsSecond
 */
export const getV7OracleSessionsSecond = (
  params: MaybeRef<GetV7OracleSessionsSecondParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInt>(
    { url: `/api/v7/oracle/sessions-second`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSessionsSecondQueryKey = (
  params?: MaybeRef<GetV7OracleSessionsSecondParams>,
) => {
  return ['api', 'v7', 'oracle', 'sessions-second', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSessionsSecondQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSessionsSecond>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSessionsSecondParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSessionsSecond>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSessionsSecondQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSessionsSecond>>> = ({
    signal,
  }) => getV7OracleSessionsSecond(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSessionsSecond>>,
    TError,
    TData
  >;
};

export type GetV7OracleSessionsSecondQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSessionsSecond>>
>;
export type GetV7OracleSessionsSecondQueryError = ErrorType<unknown>;

/**
 * @summary sessionsSecond
 */

export function useGetV7OracleSessionsSecond<
  TData = Awaited<ReturnType<typeof getV7OracleSessionsSecond>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSessionsSecondParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSessionsSecond>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSessionsSecondQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlByInterval
 */
export const getV7OracleSqlByInterval = (
  params: MaybeRef<GetV7OracleSqlByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlIntervalV7Response>(
    { url: `/api/v7/oracle/sql-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSqlByIntervalQueryKey = (
  params?: MaybeRef<GetV7OracleSqlByIntervalParams>,
) => {
  return ['api', 'v7', 'oracle', 'sql-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSqlByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSqlByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSqlByInterval>>> = ({
    signal,
  }) => getV7OracleSqlByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSqlByInterval>>,
    TError,
    TData
  >;
};

export type GetV7OracleSqlByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSqlByInterval>>
>;
export type GetV7OracleSqlByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary sqlByInterval
 */

export function useGetV7OracleSqlByInterval<
  TData = Awaited<ReturnType<typeof getV7OracleSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSqlByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlByIntervalMulti
 */
export const getV7OracleSqlByIntervalMulti = (
  params: MaybeRef<GetV7OracleSqlByIntervalMultiParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlIntervalMultiV7Response>(
    { url: `/api/v7/oracle/sql-by-interval-multi`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSqlByIntervalMultiQueryKey = (
  params?: MaybeRef<GetV7OracleSqlByIntervalMultiParams>,
) => {
  return ['api', 'v7', 'oracle', 'sql-by-interval-multi', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSqlByIntervalMultiQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSqlByIntervalMulti>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlByIntervalMultiParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlByIntervalMulti>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSqlByIntervalMultiQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSqlByIntervalMulti>>> = ({
    signal,
  }) => getV7OracleSqlByIntervalMulti(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSqlByIntervalMulti>>,
    TError,
    TData
  >;
};

export type GetV7OracleSqlByIntervalMultiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSqlByIntervalMulti>>
>;
export type GetV7OracleSqlByIntervalMultiQueryError = ErrorType<unknown>;

/**
 * @summary sqlByIntervalMulti
 */

export function useGetV7OracleSqlByIntervalMulti<
  TData = Awaited<ReturnType<typeof getV7OracleSqlByIntervalMulti>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlByIntervalMultiParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlByIntervalMulti>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSqlByIntervalMultiQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlGroupByPlanHashValue
 */
export const getV7OracleSqlByPlan = (
  params: MaybeRef<GetV7OracleSqlByPlanParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlByPlanV7Response>(
    { url: `/api/v7/oracle/sql-by-plan`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSqlByPlanQueryKey = (params?: MaybeRef<GetV7OracleSqlByPlanParams>) => {
  return ['api', 'v7', 'oracle', 'sql-by-plan', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSqlByPlanQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSqlByPlan>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlByPlanParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlByPlan>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSqlByPlanQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSqlByPlan>>> = ({ signal }) =>
    getV7OracleSqlByPlan(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSqlByPlan>>,
    TError,
    TData
  >;
};

export type GetV7OracleSqlByPlanQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSqlByPlan>>
>;
export type GetV7OracleSqlByPlanQueryError = ErrorType<unknown>;

/**
 * @summary sqlGroupByPlanHashValue
 */

export function useGetV7OracleSqlByPlan<
  TData = Awaited<ReturnType<typeof getV7OracleSqlByPlan>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlByPlanParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlByPlan>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSqlByPlanQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getSqlList
 */
export const getV7OracleSqlList = (
  params: MaybeRef<GetV7OracleSqlListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlListByIntervalV7Response>(
    { url: `/api/v7/oracle/sql-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSqlListQueryKey = (params?: MaybeRef<GetV7OracleSqlListParams>) => {
  return ['api', 'v7', 'oracle', 'sql-list', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSqlListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSqlList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSqlListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSqlList>>> = ({ signal }) =>
    getV7OracleSqlList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSqlList>>,
    TError,
    TData
  >;
};

export type GetV7OracleSqlListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSqlList>>
>;
export type GetV7OracleSqlListQueryError = ErrorType<unknown>;

/**
 * @summary getSqlList
 */

export function useGetV7OracleSqlList<
  TData = Awaited<ReturnType<typeof getV7OracleSqlList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSqlListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlListByInterval
 */
export const getV7OracleSqlListByInterval = (
  params: MaybeRef<GetV7OracleSqlListByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlListByIntervalV7Response>(
    { url: `/api/v7/oracle/sql-list-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSqlListByIntervalQueryKey = (
  params?: MaybeRef<GetV7OracleSqlListByIntervalParams>,
) => {
  return ['api', 'v7', 'oracle', 'sql-list-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSqlListByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSqlListByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSqlListByInterval>>> = ({
    signal,
  }) => getV7OracleSqlListByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSqlListByInterval>>,
    TError,
    TData
  >;
};

export type GetV7OracleSqlListByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSqlListByInterval>>
>;
export type GetV7OracleSqlListByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary sqlListByInterval
 */

export function useGetV7OracleSqlListByInterval<
  TData = Awaited<ReturnType<typeof getV7OracleSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSqlListByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlSummary
 */
export const getV7OracleSqlSummary = (
  params: MaybeRef<GetV7OracleSqlSummaryParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlSummaryV7Response>(
    { url: `/api/v7/oracle/sql-summary`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSqlSummaryQueryKey = (
  params?: MaybeRef<GetV7OracleSqlSummaryParams>,
) => {
  return ['api', 'v7', 'oracle', 'sql-summary', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSqlSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSqlSummary>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlSummaryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSqlSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSqlSummary>>> = ({ signal }) =>
    getV7OracleSqlSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSqlSummary>>,
    TError,
    TData
  >;
};

export type GetV7OracleSqlSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSqlSummary>>
>;
export type GetV7OracleSqlSummaryQueryError = ErrorType<unknown>;

/**
 * @summary sqlSummary
 */

export function useGetV7OracleSqlSummary<
  TData = Awaited<ReturnType<typeof getV7OracleSqlSummary>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlSummaryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSqlSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlSummaryList
 */
export const getV7OracleSqlSummaryList = (
  params: MaybeRef<GetV7OracleSqlSummaryListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlSummaryListV7Response>(
    { url: `/api/v7/oracle/sql-summary-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSqlSummaryListQueryKey = (
  params?: MaybeRef<GetV7OracleSqlSummaryListParams>,
) => {
  return ['api', 'v7', 'oracle', 'sql-summary-list', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSqlSummaryListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSqlSummaryList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlSummaryListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlSummaryList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSqlSummaryListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSqlSummaryList>>> = ({
    signal,
  }) => getV7OracleSqlSummaryList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSqlSummaryList>>,
    TError,
    TData
  >;
};

export type GetV7OracleSqlSummaryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSqlSummaryList>>
>;
export type GetV7OracleSqlSummaryListQueryError = ErrorType<unknown>;

/**
 * @summary sqlSummaryList
 */

export function useGetV7OracleSqlSummaryList<
  TData = Awaited<ReturnType<typeof getV7OracleSqlSummaryList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlSummaryListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqlSummaryList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSqlSummaryListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 구 sqls
 */
export const getV7OracleSqls = (
  params: MaybeRef<GetV7OracleSqlsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlRtmSummaryV7Response>(
    { url: `/api/v7/oracle/sqls`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleSqlsQueryKey = (params?: MaybeRef<GetV7OracleSqlsParams>) => {
  return ['api', 'v7', 'oracle', 'sqls', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSqlsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSqls>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqls>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSqlsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleSqls>>> = ({ signal }) =>
    getV7OracleSqls(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSqls>>,
    TError,
    TData
  >;
};

export type GetV7OracleSqlsQueryResult = NonNullable<Awaited<ReturnType<typeof getV7OracleSqls>>>;
export type GetV7OracleSqlsQueryError = ErrorType<unknown>;

/**
 * @summary 구 sqls
 */

export function useGetV7OracleSqls<
  TData = Awaited<ReturnType<typeof getV7OracleSqls>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSqlsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7OracleSqls>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSqlsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary tablespaceByInterval
 */
export const getV7OracleTablespaceByInterval = (
  params: MaybeRef<GetV7OracleTablespaceByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TablespaceByIntervalV7Response>(
    { url: `/api/v7/oracle/tablespace-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleTablespaceByIntervalQueryKey = (
  params?: MaybeRef<GetV7OracleTablespaceByIntervalParams>,
) => {
  return ['api', 'v7', 'oracle', 'tablespace-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleTablespaceByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleTablespaceByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTablespaceByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTablespaceByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleTablespaceByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleTablespaceByInterval>>> = ({
    signal,
  }) => getV7OracleTablespaceByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleTablespaceByInterval>>,
    TError,
    TData
  >;
};

export type GetV7OracleTablespaceByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleTablespaceByInterval>>
>;
export type GetV7OracleTablespaceByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary tablespaceByInterval
 */

export function useGetV7OracleTablespaceByInterval<
  TData = Awaited<ReturnType<typeof getV7OracleTablespaceByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTablespaceByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTablespaceByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleTablespaceByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary tempIntervalSummary
 */
export const getV7OracleTempInterval = (
  params: MaybeRef<GetV7OracleTempIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TempIntervalSummaryV7Response>(
    { url: `/api/v7/oracle/temp-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleTempIntervalQueryKey = (
  params?: MaybeRef<GetV7OracleTempIntervalParams>,
) => {
  return ['api', 'v7', 'oracle', 'temp-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleTempIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleTempInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTempIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTempInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleTempIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleTempInterval>>> = ({
    signal,
  }) => getV7OracleTempInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleTempInterval>>,
    TError,
    TData
  >;
};

export type GetV7OracleTempIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleTempInterval>>
>;
export type GetV7OracleTempIntervalQueryError = ErrorType<unknown>;

/**
 * @summary tempIntervalSummary
 */

export function useGetV7OracleTempInterval<
  TData = Awaited<ReturnType<typeof getV7OracleTempInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTempIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTempInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleTempIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [오라클] 멀티뷰 - 바차트 클릭시 출력되는 area 차트 영역
 */
export const getV7OracleTimeModelByInterval = (
  params: MaybeRef<GetV7OracleTimeModelByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TimeModelByIntervalV7Response>(
    { url: `/api/v7/oracle/time-model-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleTimeModelByIntervalQueryKey = (
  params?: MaybeRef<GetV7OracleTimeModelByIntervalParams>,
) => {
  return ['api', 'v7', 'oracle', 'time-model-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleTimeModelByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleTimeModelByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTimeModelByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTimeModelByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleTimeModelByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleTimeModelByInterval>>> = ({
    signal,
  }) => getV7OracleTimeModelByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleTimeModelByInterval>>,
    TError,
    TData
  >;
};

export type GetV7OracleTimeModelByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleTimeModelByInterval>>
>;
export type GetV7OracleTimeModelByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary [오라클] 멀티뷰 - 바차트 클릭시 출력되는 area 차트 영역
 */

export function useGetV7OracleTimeModelByInterval<
  TData = Awaited<ReturnType<typeof getV7OracleTimeModelByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTimeModelByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTimeModelByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleTimeModelByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary timeModelByIntervalPost
 */
export const postV7OracleTimeModelByInterval = (
  multiInstanceRequestBody: MaybeRef<MultiInstanceRequestBody>,
  params?: MaybeRef<PostV7OracleTimeModelByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiInstanceRequestBody = unref(multiInstanceRequestBody);
  params = unref(params);

  return customAxiosInstance<TimeModelByIntervalV7Response>(
    {
      url: `/api/v7/oracle/time-model-by-interval`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiInstanceRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7OracleTimeModelByIntervalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7OracleTimeModelByInterval>>,
    TError,
    { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleTimeModelByIntervalParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7OracleTimeModelByInterval>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleTimeModelByIntervalParams },
  TContext
> => {
  const mutationKey = ['postV7OracleTimeModelByInterval'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7OracleTimeModelByInterval>>,
    { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleTimeModelByIntervalParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV7OracleTimeModelByInterval(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7OracleTimeModelByIntervalMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7OracleTimeModelByInterval>>
>;
export type PostV7OracleTimeModelByIntervalMutationBody = BodyType<MultiInstanceRequestBody>;
export type PostV7OracleTimeModelByIntervalMutationError = ErrorType<unknown>;

/**
 * @summary timeModelByIntervalPost
 */
export const usePostV7OracleTimeModelByInterval = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7OracleTimeModelByInterval>>,
      TError,
      { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleTimeModelByIntervalParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7OracleTimeModelByInterval>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleTimeModelByIntervalParams },
  TContext
> => {
  const mutationOptions = getPostV7OracleTimeModelByIntervalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary topModule
 */
export const getV7OracleTopModule = (
  params: MaybeRef<GetV7OracleTopModuleParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TopModuleV7Response>(
    { url: `/api/v7/oracle/top-module`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleTopModuleQueryKey = (params?: MaybeRef<GetV7OracleTopModuleParams>) => {
  return ['api', 'v7', 'oracle', 'top-module', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleTopModuleQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleTopModule>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopModuleParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopModule>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleTopModuleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleTopModule>>> = ({ signal }) =>
    getV7OracleTopModule(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleTopModule>>,
    TError,
    TData
  >;
};

export type GetV7OracleTopModuleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleTopModule>>
>;
export type GetV7OracleTopModuleQueryError = ErrorType<unknown>;

/**
 * @summary topModule
 */

export function useGetV7OracleTopModule<
  TData = Awaited<ReturnType<typeof getV7OracleTopModule>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopModuleParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopModule>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleTopModuleQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary topSchema
 */
export const getV7OracleTopSchema = (
  params: MaybeRef<GetV7OracleTopSchemaParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TopSchemaV7Response>(
    { url: `/api/v7/oracle/top-schema`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleTopSchemaQueryKey = (params?: MaybeRef<GetV7OracleTopSchemaParams>) => {
  return ['api', 'v7', 'oracle', 'top-schema', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleTopSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleTopSchema>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopSchemaParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleTopSchemaQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleTopSchema>>> = ({ signal }) =>
    getV7OracleTopSchema(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleTopSchema>>,
    TError,
    TData
  >;
};

export type GetV7OracleTopSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleTopSchema>>
>;
export type GetV7OracleTopSchemaQueryError = ErrorType<unknown>;

/**
 * @summary topSchema
 */

export function useGetV7OracleTopSchema<
  TData = Awaited<ReturnType<typeof getV7OracleTopSchema>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopSchemaParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleTopSchemaQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary PA > Oracle > TableSpace > Top 100 Segment
 */
export const getV7OracleTopSegment = (
  params: MaybeRef<GetV7OracleTopSegmentParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TopSegmentV7Response>(
    { url: `/api/v7/oracle/top-segment`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleTopSegmentQueryKey = (
  params?: MaybeRef<GetV7OracleTopSegmentParams>,
) => {
  return ['api', 'v7', 'oracle', 'top-segment', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleTopSegmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleTopSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopSegmentParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopSegment>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleTopSegmentQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleTopSegment>>> = ({ signal }) =>
    getV7OracleTopSegment(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleTopSegment>>,
    TError,
    TData
  >;
};

export type GetV7OracleTopSegmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleTopSegment>>
>;
export type GetV7OracleTopSegmentQueryError = ErrorType<unknown>;

/**
 * @summary PA > Oracle > TableSpace > Top 100 Segment
 */

export function useGetV7OracleTopSegment<
  TData = Awaited<ReturnType<typeof getV7OracleTopSegment>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopSegmentParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopSegment>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleTopSegmentQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary topSql
 */
export const getV7OracleTopSql = (
  params: MaybeRef<GetV7OracleTopSqlParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TopSqlV7Response>(
    { url: `/api/v7/oracle/top-sql`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleTopSqlQueryKey = (params?: MaybeRef<GetV7OracleTopSqlParams>) => {
  return ['api', 'v7', 'oracle', 'top-sql', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleTopSqlQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleTopSql>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopSqlParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopSql>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleTopSqlQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleTopSql>>> = ({ signal }) =>
    getV7OracleTopSql(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleTopSql>>,
    TError,
    TData
  >;
};

export type GetV7OracleTopSqlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleTopSql>>
>;
export type GetV7OracleTopSqlQueryError = ErrorType<unknown>;

/**
 * @summary topSql
 */

export function useGetV7OracleTopSql<
  TData = Awaited<ReturnType<typeof getV7OracleTopSql>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopSqlParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopSql>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleTopSqlQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary topTablespace
 */
export const getV7OracleTopTablespace = (
  params: MaybeRef<GetV7OracleTopTablespaceParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TopTablespaceV7Response>(
    { url: `/api/v7/oracle/top-tablespace`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleTopTablespaceQueryKey = (
  params?: MaybeRef<GetV7OracleTopTablespaceParams>,
) => {
  return ['api', 'v7', 'oracle', 'top-tablespace', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleTopTablespaceQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleTopTablespace>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopTablespaceParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopTablespace>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleTopTablespaceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleTopTablespace>>> = ({
    signal,
  }) => getV7OracleTopTablespace(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleTopTablespace>>,
    TError,
    TData
  >;
};

export type GetV7OracleTopTablespaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleTopTablespace>>
>;
export type GetV7OracleTopTablespaceQueryError = ErrorType<unknown>;

/**
 * @summary topTablespace
 */

export function useGetV7OracleTopTablespace<
  TData = Awaited<ReturnType<typeof getV7OracleTopTablespace>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleTopTablespaceParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleTopTablespace>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleTopTablespaceQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary undoIntervalSummary
 */
export const getV7OracleUndoInterval = (
  params: MaybeRef<GetV7OracleUndoIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<UndoIntervalSummaryV7Response>(
    { url: `/api/v7/oracle/undo-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleUndoIntervalQueryKey = (
  params?: MaybeRef<GetV7OracleUndoIntervalParams>,
) => {
  return ['api', 'v7', 'oracle', 'undo-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleUndoIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleUndoInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleUndoIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleUndoInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleUndoIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleUndoInterval>>> = ({
    signal,
  }) => getV7OracleUndoInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleUndoInterval>>,
    TError,
    TData
  >;
};

export type GetV7OracleUndoIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleUndoInterval>>
>;
export type GetV7OracleUndoIntervalQueryError = ErrorType<unknown>;

/**
 * @summary undoIntervalSummary
 */

export function useGetV7OracleUndoInterval<
  TData = Awaited<ReturnType<typeof getV7OracleUndoInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleUndoIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleUndoInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleUndoIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary topUndoTempPost
 */
export const postV7OracleUndoTempRatio = (
  multiInstanceRequestBody: MaybeRef<MultiInstanceRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiInstanceRequestBody = unref(multiInstanceRequestBody);

  return customAxiosInstance<UndoTempRatioV7Response>(
    {
      url: `/api/v7/oracle/undo-temp-ratio`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiInstanceRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV7OracleUndoTempRatioMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7OracleUndoTempRatio>>,
    TError,
    { data: BodyType<MultiInstanceRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7OracleUndoTempRatio>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody> },
  TContext
> => {
  const mutationKey = ['postV7OracleUndoTempRatio'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7OracleUndoTempRatio>>,
    { data: BodyType<MultiInstanceRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7OracleUndoTempRatio(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7OracleUndoTempRatioMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7OracleUndoTempRatio>>
>;
export type PostV7OracleUndoTempRatioMutationBody = BodyType<MultiInstanceRequestBody>;
export type PostV7OracleUndoTempRatioMutationError = ErrorType<unknown>;

/**
 * @summary topUndoTempPost
 */
export const usePostV7OracleUndoTempRatio = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7OracleUndoTempRatio>>,
      TError,
      { data: BodyType<MultiInstanceRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7OracleUndoTempRatio>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV7OracleUndoTempRatioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary waitChainWithDeadLock
 */
export const getV7OracleWaitChain = (
  params: MaybeRef<GetV7OracleWaitChainParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WaitChainWithDeadLockV7Response>(
    { url: `/api/v7/oracle/wait-chain`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleWaitChainQueryKey = (params?: MaybeRef<GetV7OracleWaitChainParams>) => {
  return ['api', 'v7', 'oracle', 'wait-chain', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleWaitChainQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleWaitChain>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitChainParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitChain>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleWaitChainQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleWaitChain>>> = ({ signal }) =>
    getV7OracleWaitChain(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleWaitChain>>,
    TError,
    TData
  >;
};

export type GetV7OracleWaitChainQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleWaitChain>>
>;
export type GetV7OracleWaitChainQueryError = ErrorType<unknown>;

/**
 * @summary waitChainWithDeadLock
 */

export function useGetV7OracleWaitChain<
  TData = Awaited<ReturnType<typeof getV7OracleWaitChain>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitChainParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitChain>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleWaitChainQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary waitChainWithDeadLockSecond
 */
export const getV7OracleWaitChainSecond = (
  params: MaybeRef<GetV7OracleWaitChainSecondParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInt>(
    { url: `/api/v7/oracle/wait-chain-second`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleWaitChainSecondQueryKey = (
  params?: MaybeRef<GetV7OracleWaitChainSecondParams>,
) => {
  return ['api', 'v7', 'oracle', 'wait-chain-second', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleWaitChainSecondQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleWaitChainSecond>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitChainSecondParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitChainSecond>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleWaitChainSecondQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleWaitChainSecond>>> = ({
    signal,
  }) => getV7OracleWaitChainSecond(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleWaitChainSecond>>,
    TError,
    TData
  >;
};

export type GetV7OracleWaitChainSecondQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleWaitChainSecond>>
>;
export type GetV7OracleWaitChainSecondQueryError = ErrorType<unknown>;

/**
 * @summary waitChainWithDeadLockSecond
 */

export function useGetV7OracleWaitChainSecond<
  TData = Awaited<ReturnType<typeof getV7OracleWaitChainSecond>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitChainSecondParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitChainSecond>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleWaitChainSecondQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [오라클] 멀티뷰 > 바차트 클릭시 출력되는 Area 차트 영역 & 인스턴스 디테일 > 이벤트
 */
export const getV7OracleWaitClass = (
  params: MaybeRef<GetV7OracleWaitClassParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WaitClassV7Response>(
    { url: `/api/v7/oracle/wait-class`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleWaitClassQueryKey = (params?: MaybeRef<GetV7OracleWaitClassParams>) => {
  return ['api', 'v7', 'oracle', 'wait-class', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleWaitClassQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleWaitClass>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitClassParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitClass>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleWaitClassQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleWaitClass>>> = ({ signal }) =>
    getV7OracleWaitClass(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleWaitClass>>,
    TError,
    TData
  >;
};

export type GetV7OracleWaitClassQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleWaitClass>>
>;
export type GetV7OracleWaitClassQueryError = ErrorType<unknown>;

/**
 * @summary [오라클] 멀티뷰 > 바차트 클릭시 출력되는 Area 차트 영역 & 인스턴스 디테일 > 이벤트
 */

export function useGetV7OracleWaitClass<
  TData = Awaited<ReturnType<typeof getV7OracleWaitClass>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitClassParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitClass>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleWaitClassQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [오라클] 멀티뷰 - Wait Class 바차트 영역
 */
export const postV7OracleWaitClass = (
  multiInstanceRequestBody: MaybeRef<MultiInstanceRequestBody>,
  params?: MaybeRef<PostV7OracleWaitClassParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiInstanceRequestBody = unref(multiInstanceRequestBody);
  params = unref(params);

  return customAxiosInstance<WaitClassV7Response>(
    {
      url: `/api/v7/oracle/wait-class`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiInstanceRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7OracleWaitClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7OracleWaitClass>>,
    TError,
    { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleWaitClassParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7OracleWaitClass>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleWaitClassParams },
  TContext
> => {
  const mutationKey = ['postV7OracleWaitClass'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7OracleWaitClass>>,
    { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleWaitClassParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV7OracleWaitClass(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7OracleWaitClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7OracleWaitClass>>
>;
export type PostV7OracleWaitClassMutationBody = BodyType<MultiInstanceRequestBody>;
export type PostV7OracleWaitClassMutationError = ErrorType<unknown>;

/**
 * @summary [오라클] 멀티뷰 - Wait Class 바차트 영역
 */
export const usePostV7OracleWaitClass = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7OracleWaitClass>>,
      TError,
      { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleWaitClassParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7OracleWaitClass>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params?: PostV7OracleWaitClassParams },
  TContext
> => {
  const mutationOptions = getPostV7OracleWaitClassMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary waitClassRatio
 */
export const getV7OracleWaitClassRatio = (
  params: MaybeRef<GetV7OracleWaitClassRatioParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WaitClassRatioV7Response>(
    { url: `/api/v7/oracle/wait-class-ratio`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleWaitClassRatioQueryKey = (
  params?: MaybeRef<GetV7OracleWaitClassRatioParams>,
) => {
  return ['api', 'v7', 'oracle', 'wait-class-ratio', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleWaitClassRatioQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleWaitClassRatio>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitClassRatioParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitClassRatio>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleWaitClassRatioQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleWaitClassRatio>>> = ({
    signal,
  }) => getV7OracleWaitClassRatio(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleWaitClassRatio>>,
    TError,
    TData
  >;
};

export type GetV7OracleWaitClassRatioQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleWaitClassRatio>>
>;
export type GetV7OracleWaitClassRatioQueryError = ErrorType<unknown>;

/**
 * @summary waitClassRatio
 */

export function useGetV7OracleWaitClassRatio<
  TData = Awaited<ReturnType<typeof getV7OracleWaitClassRatio>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitClassRatioParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitClassRatio>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleWaitClassRatioQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary PA > Oracle > Wait Summary인스턴스 디테일 > 이벤트Multi View 하단 Session Tab 의 Event tab
 */
export const getV7OracleWaitEvent = (
  params: MaybeRef<GetV7OracleWaitEventParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<WaitEventResponse>(
    { url: `/api/v7/oracle/wait-event`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleWaitEventQueryKey = (params?: MaybeRef<GetV7OracleWaitEventParams>) => {
  return ['api', 'v7', 'oracle', 'wait-event', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleWaitEventQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleWaitEvent>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitEventParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitEvent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleWaitEventQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleWaitEvent>>> = ({ signal }) =>
    getV7OracleWaitEvent(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleWaitEvent>>,
    TError,
    TData
  >;
};

export type GetV7OracleWaitEventQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleWaitEvent>>
>;
export type GetV7OracleWaitEventQueryError = ErrorType<unknown>;

/**
 * @summary PA > Oracle > Wait Summary인스턴스 디테일 > 이벤트Multi View 하단 Session Tab 의 Event tab
 */

export function useGetV7OracleWaitEvent<
  TData = Awaited<ReturnType<typeof getV7OracleWaitEvent>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitEventParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitEvent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleWaitEventQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlListByWaitEvent
 */
export const getV7OracleWaitSqlList = (
  params: MaybeRef<GetV7OracleWaitSqlListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlByWaitEventV7Response>(
    { url: `/api/v7/oracle/wait-sql-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OracleWaitSqlListQueryKey = (
  params?: MaybeRef<GetV7OracleWaitSqlListParams>,
) => {
  return ['api', 'v7', 'oracle', 'wait-sql-list', ...(params ? [params] : [])] as const;
};

export const getGetV7OracleWaitSqlListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleWaitSqlList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitSqlListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitSqlList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleWaitSqlListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OracleWaitSqlList>>> = ({ signal }) =>
    getV7OracleWaitSqlList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleWaitSqlList>>,
    TError,
    TData
  >;
};

export type GetV7OracleWaitSqlListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleWaitSqlList>>
>;
export type GetV7OracleWaitSqlListQueryError = ErrorType<unknown>;

/**
 * @summary sqlListByWaitEvent
 */

export function useGetV7OracleWaitSqlList<
  TData = Awaited<ReturnType<typeof getV7OracleWaitSqlList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleWaitSqlListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OracleWaitSqlList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleWaitSqlListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Oracle - 파라미터 디테일 (Information과 History 분리)
 */
export const getV7OracleParameterDetailByInstanceIdAndParameterName = (
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7OracleParameterDetailByInstanceIdAndParameterNameParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  parameterName = unref(parameterName);
  params = unref(params);

  return customAxiosInstance<ApiResponseOracleParameterDetailRs>(
    {
      url: `/api/v7/oracle/${instanceId}/parameter/${parameterName}/detail`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7OracleParameterDetailByInstanceIdAndParameterNameQueryKey = (
  instanceId?: MaybeRef<string>,
  parameterName?: MaybeRef<string>,
  params?: MaybeRef<GetV7OracleParameterDetailByInstanceIdAndParameterNameParams>,
) => {
  return [
    'api',
    'v7',
    'oracle',
    instanceId,
    'parameter',
    parameterName,
    'detail',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7OracleParameterDetailByInstanceIdAndParameterNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7OracleParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleParameterDetailByInstanceIdAndParameterNameQueryKey(
    instanceId,
    parameterName,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7OracleParameterDetailByInstanceIdAndParameterName>>
  > = ({ signal }) =>
    getV7OracleParameterDetailByInstanceIdAndParameterName(
      instanceId,
      parameterName,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(parameterName))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleParameterDetailByInstanceIdAndParameterName>>,
    TError,
    TData
  >;
};

export type GetV7OracleParameterDetailByInstanceIdAndParameterNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleParameterDetailByInstanceIdAndParameterName>>
>;
export type GetV7OracleParameterDetailByInstanceIdAndParameterNameQueryError = ErrorType<unknown>;

/**
 * @summary Oracle - 파라미터 디테일 (Information과 History 분리)
 */

export function useGetV7OracleParameterDetailByInstanceIdAndParameterName<
  TData = Awaited<ReturnType<typeof getV7OracleParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7OracleParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleParameterDetailByInstanceIdAndParameterNameQueryOptions(
    instanceId,
    parameterName,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Plan Analysis] Plan 탭 정보
 */
export const getV7OraclePlanByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OraclePlanByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<SqlPlanV4Response>(
    { url: `/api/v7/oracle/${instanceId}/plan`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7OraclePlanByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7OraclePlanByInstanceIdParams>,
) => {
  return ['api', 'v7', 'oracle', instanceId, 'plan', ...(params ? [params] : [])] as const;
};

export const getGetV7OraclePlanByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OraclePlanByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OraclePlanByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OraclePlanByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OraclePlanByInstanceId>>> = ({
    signal,
  }) => getV7OraclePlanByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanByInstanceId>>, TError, TData>;
};

export type GetV7OraclePlanByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OraclePlanByInstanceId>>
>;
export type GetV7OraclePlanByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Plan Analysis] Plan 탭 정보
 */

export function useGetV7OraclePlanByInstanceId<
  TData = Awaited<ReturnType<typeof getV7OraclePlanByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OraclePlanByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OraclePlanByInstanceIdQueryOptions(instanceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 세션 매니저 리스트 조회
 */
export const getV7OracleSessionManagerListByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OracleSessionManagerListByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseSessionManagerRS>(
    {
      url: `/api/v7/oracle/${instanceId}/session-manager-list`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7OracleSessionManagerListByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7OracleSessionManagerListByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'oracle',
    instanceId,
    'session-manager-list',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7OracleSessionManagerListByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSessionManagerListByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OracleSessionManagerListByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleSessionManagerListByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSessionManagerListByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7OracleSessionManagerListByInstanceId>>
  > = ({ signal }) =>
    getV7OracleSessionManagerListByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSessionManagerListByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7OracleSessionManagerListByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSessionManagerListByInstanceId>>
>;
export type GetV7OracleSessionManagerListByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 세션 매니저 리스트 조회
 */

export function useGetV7OracleSessionManagerListByInstanceId<
  TData = Awaited<ReturnType<typeof getV7OracleSessionManagerListByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OracleSessionManagerListByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleSessionManagerListByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSessionManagerListByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 인스턴스 디테일 > 세션 탭 > 세션 멀티 킬
 */
export const postV7OracleSessionsKillSessionByInstanceId = (
  params: MaybeRef<PostV7OracleSessionsKillSessionByInstanceIdParams>,
  instanceId: MaybeRef<string> = '5b81987c-9192-4516-ab70-87c235923445',
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);
  instanceId = unref(instanceId);

  return customAxiosInstance<string>(
    {
      url: `/api/v7/oracle/${instanceId}/sessions/kill-session`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7OracleSessionsKillSessionByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7OracleSessionsKillSessionByInstanceId>>,
    TError,
    { params: PostV7OracleSessionsKillSessionByInstanceIdParams; instanceId?: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7OracleSessionsKillSessionByInstanceId>>,
  TError,
  { params: PostV7OracleSessionsKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationKey = ['postV7OracleSessionsKillSessionByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7OracleSessionsKillSessionByInstanceId>>,
    { params: PostV7OracleSessionsKillSessionByInstanceIdParams; instanceId?: string }
  > = (props) => {
    const { params, instanceId } = props ?? {};

    return postV7OracleSessionsKillSessionByInstanceId(params, instanceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7OracleSessionsKillSessionByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7OracleSessionsKillSessionByInstanceId>>
>;

export type PostV7OracleSessionsKillSessionByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 인스턴스 디테일 > 세션 탭 > 세션 멀티 킬
 */
export const usePostV7OracleSessionsKillSessionByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7OracleSessionsKillSessionByInstanceId>>,
      TError,
      { params: PostV7OracleSessionsKillSessionByInstanceIdParams; instanceId?: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7OracleSessionsKillSessionByInstanceId>>,
  TError,
  { params: PostV7OracleSessionsKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationOptions = getPostV7OracleSessionsKillSessionByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary sessionMetricV4
 */
export const getV7OracleSessionsMetricByInstanceId = (
  params: MaybeRef<GetV7OracleSessionsMetricByInstanceIdParams>,
  instanceId: MaybeRef<string> = '44291bf7-1d03-430a-9aef-20137a019ddb',
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);
  instanceId = unref(instanceId);

  return customAxiosInstance<SessionMetricV4Response>(
    {
      url: `/api/v7/oracle/${instanceId}/sessions/metric`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7OracleSessionsMetricByInstanceIdQueryKey = (
  params?: MaybeRef<GetV7OracleSessionsMetricByInstanceIdParams>,
  instanceId: MaybeRef<string> = '44291bf7-1d03-430a-9aef-20137a019ddb',
) => {
  return [
    'api',
    'v7',
    'oracle',
    instanceId,
    'sessions',
    'metric',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7OracleSessionsMetricByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSessionsMetricByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSessionsMetricByInstanceIdParams>,
  instanceId: MaybeRef<string> = '44291bf7-1d03-430a-9aef-20137a019ddb',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleSessionsMetricByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSessionsMetricByInstanceIdQueryKey(params, instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7OracleSessionsMetricByInstanceId>>
  > = ({ signal }) =>
    getV7OracleSessionsMetricByInstanceId(params, instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSessionsMetricByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7OracleSessionsMetricByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSessionsMetricByInstanceId>>
>;
export type GetV7OracleSessionsMetricByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary sessionMetricV4
 */

export function useGetV7OracleSessionsMetricByInstanceId<
  TData = Awaited<ReturnType<typeof getV7OracleSessionsMetricByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7OracleSessionsMetricByInstanceIdParams>,
  instanceId: MaybeRef<string> = '44291bf7-1d03-430a-9aef-20137a019ddb',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleSessionsMetricByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSessionsMetricByInstanceIdQueryOptions(
    params,
    instanceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getSessionTargetDetail
 */
export const getV7OracleSessionsByInstanceIdAndSid = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OracleSessionsByInstanceIdAndSidParams>,
  sid: MaybeRef<number> = 19470,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);
  sid = unref(sid);

  return customAxiosInstance<SessionTargetDetailV7Response>(
    {
      url: `/api/v7/oracle/${instanceId}/sessions/${sid}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7OracleSessionsByInstanceIdAndSidQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7OracleSessionsByInstanceIdAndSidParams>,
  sid: MaybeRef<number> = 19470,
) => {
  return ['api', 'v7', 'oracle', instanceId, 'sessions', sid, ...(params ? [params] : [])] as const;
};

export const getGetV7OracleSessionsByInstanceIdAndSidQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSessionsByInstanceIdAndSid>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OracleSessionsByInstanceIdAndSidParams>,
  sid: MaybeRef<number> = 19470,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleSessionsByInstanceIdAndSid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSessionsByInstanceIdAndSidQueryKey(instanceId, params, sid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7OracleSessionsByInstanceIdAndSid>>
  > = ({ signal }) =>
    getV7OracleSessionsByInstanceIdAndSid(instanceId, params, sid, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(sid))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSessionsByInstanceIdAndSid>>,
    TError,
    TData
  >;
};

export type GetV7OracleSessionsByInstanceIdAndSidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSessionsByInstanceIdAndSid>>
>;
export type GetV7OracleSessionsByInstanceIdAndSidQueryError = ErrorType<unknown>;

/**
 * @summary getSessionTargetDetail
 */

export function useGetV7OracleSessionsByInstanceIdAndSid<
  TData = Awaited<ReturnType<typeof getV7OracleSessionsByInstanceIdAndSid>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OracleSessionsByInstanceIdAndSidParams>,
  sid: MaybeRef<number> = 19470,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleSessionsByInstanceIdAndSid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSessionsByInstanceIdAndSidQueryOptions(
    instanceId,
    params,
    sid,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlPlanReason
 */
export const getV7OracleSqlPlanReasonByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OracleSqlPlanReasonByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<SqlPlanReasonV7Response>(
    {
      url: `/api/v7/oracle/${instanceId}/sql-plan-reason`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7OracleSqlPlanReasonByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7OracleSqlPlanReasonByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'oracle',
    instanceId,
    'sql-plan-reason',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7OracleSqlPlanReasonByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OracleSqlPlanReasonByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OracleSqlPlanReasonByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleSqlPlanReasonByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OracleSqlPlanReasonByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7OracleSqlPlanReasonByInstanceId>>
  > = ({ signal }) =>
    getV7OracleSqlPlanReasonByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7OracleSqlPlanReasonByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7OracleSqlPlanReasonByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OracleSqlPlanReasonByInstanceId>>
>;
export type GetV7OracleSqlPlanReasonByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary sqlPlanReason
 */

export function useGetV7OracleSqlPlanReasonByInstanceId<
  TData = Awaited<ReturnType<typeof getV7OracleSqlPlanReasonByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7OracleSqlPlanReasonByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7OracleSqlPlanReasonByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OracleSqlPlanReasonByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary planHashValuesBySqlId
 */
export const getV7OraclePlanHashValuesBySqlId = (
  sqlId: MaybeRef<string>,
  params?: MaybeRef<GetV7OraclePlanHashValuesBySqlIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  sqlId = unref(sqlId);
  params = unref(params);

  return customAxiosInstance<PlanHashValuesBySqlIdV7Response>(
    {
      url: `/api/v7/oracle/${sqlId}/plan-hash-values`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7OraclePlanHashValuesBySqlIdQueryKey = (
  sqlId?: MaybeRef<string>,
  params?: MaybeRef<GetV7OraclePlanHashValuesBySqlIdParams>,
) => {
  return ['api', 'v7', 'oracle', sqlId, 'plan-hash-values', ...(params ? [params] : [])] as const;
};

export const getGetV7OraclePlanHashValuesBySqlIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7OraclePlanHashValuesBySqlId>>,
  TError = ErrorType<unknown>,
>(
  sqlId: MaybeRef<string>,
  params?: MaybeRef<GetV7OraclePlanHashValuesBySqlIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanHashValuesBySqlId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7OraclePlanHashValuesBySqlIdQueryKey(sqlId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7OraclePlanHashValuesBySqlId>>> = ({
    signal,
  }) => getV7OraclePlanHashValuesBySqlId(sqlId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(sqlId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanHashValuesBySqlId>>, TError, TData>;
};

export type GetV7OraclePlanHashValuesBySqlIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7OraclePlanHashValuesBySqlId>>
>;
export type GetV7OraclePlanHashValuesBySqlIdQueryError = ErrorType<unknown>;

/**
 * @summary planHashValuesBySqlId
 */

export function useGetV7OraclePlanHashValuesBySqlId<
  TData = Awaited<ReturnType<typeof getV7OraclePlanHashValuesBySqlId>>,
  TError = ErrorType<unknown>,
>(
  sqlId: MaybeRef<string>,
  params?: MaybeRef<GetV7OraclePlanHashValuesBySqlIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7OraclePlanHashValuesBySqlId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7OraclePlanHashValuesBySqlIdQueryOptions(sqlId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
